import { bootstrapWidget } from "../../common";
import PropertyCardWidget from "./widget";

bootstrapWidget({ widget: PropertyCardWidget, widgetType: "property-card" });
